import { useState } from 'react';
import { config } from '../config';
import type { FormAccessMode } from '../api/types';

/** Shows the shareable respondent URL (forms.<host>/f/{id}) with a copy button. */
export function RespondentLink({
  formId,
  accessMode,
  published,
}: {
  formId: string;
  accessMode: FormAccessMode;
  published: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const url = `${config.publicFormsUrl.replace(/\/$/, '')}/f/${formId}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="secret-links">
      <h3>Respondent link</h3>
      <p className="muted">
        Share this link with respondents.{' '}
        {accessMode === 'Private'
          ? 'They will be prompted to sign in with their organisation account.'
          : 'Anyone with the link can open the form.'}
      </p>
      <div className="link-url-row">
        <code className="link-url">{url}</code>
        <button type="button" onClick={copy}>{copied ? 'Copied' : 'Copy'}</button>
        <a className="builder-link" href={url} target="_blank" rel="noreferrer">Open ↗</a>
      </div>
      {!published && (
        <p className="muted">Publish the form before sharing — unpublished forms are not available.</p>
      )}
    </div>
  );
}
